import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useQILastQuestions(
  courseSlug: string,
  subjectSlug: string,
  excludeId: number,
  iso?: string
): {
  lastQuestions: QuestionIndexing.TrQiQuestion[];
  lastQuestionsLoading: boolean;
  lastQuestionsError: any;
} {
  const shouldFetch = !!courseSlug && !!iso && !!excludeId && !!subjectSlug;

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: ["QILastQuestions", [courseSlug, iso, excludeId, subjectSlug]],
    queryFn: () =>
      fetchLastQuestions(courseSlug, {
        subjectSlug,
        excludeId,
        lang: iso,
      }),
    enabled: shouldFetch,
  });

  return {
    lastQuestions: data?.results,
    lastQuestionsLoading: isLoading || isRefetching,
    lastQuestionsError: error,
  };
}

function fetchLastQuestions(courseSlug: string, params: any) {
  return axios
    .get(`/api/questions/lastQuestions/${courseSlug}/`, {
      params,
    })
    .then((response) => response.data);
}
